<template>
	<div
		v-if="source"
		class="source-box"
		:class="{ selected: source.selected }"
		:style="{ 'background-color': source.color ? `var(${source.color})` : 'inherit' }"
		@click="onClickSourceBox"
	>
		<template v-if="source.picture">
			<img :src="source.picture" />
		</template>
		<template v-else>
			{{ source.firstLetter }}
		</template>
	</div>
</template>

<script>
export default {
	props: {
		source: {
			type: Object,
        },
	},
	methods: {
		onClickSourceBox() {
			this.$emit('click');
		},
	},
};
</script>
